import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import OfferCard from "../../offers/offerCard";
import { fetchOffers } from "../../offers/offersFirestore";

import type { Offer } from "../../../lib/types/detailsTypes";

interface OffersProps {
  storeId?: string;
}

const Offers: React.FC<OffersProps> = ({ storeId }) => {
  const [offers, setOffers] = useState<Offer[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadOffers = async () => {
      try {
        const result = await fetchOffers({ storeId: storeId });
        setOffers(result);
      } catch (err) {
        console.error("Failed to fetch offers:", err);
      } finally {
        setLoading(false);
      }
    };

    loadOffers();
  }, [storeId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: 2,
      }}
    >
      <Typography variant="h4" gutterBottom sx={{ color: "white" }}>
        <strong>Offers</strong>
      </Typography>

      {loading ? (
        <Typography variant="h6" color="textSecondary">
          Loading offers...
        </Typography>
      ) : offers.length > 0 ? (
        offers.map((offer) => <OfferCard key={offer.id} offer={offer} />)
      ) : (
        <Typography variant="h6" color="textSecondary">
          No store offers currently available
        </Typography>
      )}
    </Box>
  );
};

export default Offers;
